import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeInvoiceConfig  {
    _originalTypeClassName = "zERP.BO.BackOfficeInvoiceConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeInvoiceConfig.translate = translateService;
}
this.IssueInvoicePaymentTypes = [];
this.Id = null;
this.LastSyncDate = null;
this.LastSyncId = null;
this.MaxRowsToFetch = null;
this.Number = null;
this.DocumentType = null;
this.GroupDocuments = false;
this.EnableScheduling = false;
this.SchedulingMinutesInterval = null;
this.SchedulingHourFrom = null;
this.SchedulingHourTo = null;
this.IssueInvoice = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
LastSyncDate:any;
LastSyncId:any;
MaxRowsToFetch:any;
Number:any;
DocumentType:any;
GroupDocuments:any;
EnableScheduling:any;
SchedulingMinutesInterval:any;
SchedulingHourFrom:any;
SchedulingHourTo:any;
IssueInvoice:any;
MainTransactionEntity:any;
InvoiceType:any;
Series:any;
DefaultCashier:any;
IssueInvoicePaymentTypes:any;
static setMainTransactionEntity = ($this, value) => {
var oldValue = $this.MainTransactionEntity;
$this.MainTransactionEntity = value;
if (value != null) {
}
}
static setInvoiceType = ($this, value) => {
var oldValue = $this.InvoiceType;
$this.InvoiceType = value;
if (value != null) {
}
}
static setSeries = ($this, value) => {
var oldValue = $this.Series;
$this.Series = value;
if (value != null) {
}
}
static setDefaultCashier = ($this, value) => {
var oldValue = $this.DefaultCashier;
$this.DefaultCashier = value;
if (value != null) {
}
}
static setIssueInvoicePaymentTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.IssueInvoicePaymentTypes == null) $this.IssueInvoicePaymentTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IssueInvoicePaymentTypes.length > 0) {
                    Domain.BackOfficeInvoiceConfig.removeIssueInvoicePaymentTypes($this, $this.IssueInvoicePaymentTypes[0]);
                }

                Domain.BackOfficeInvoiceConfig.addManyIssueInvoicePaymentTypes($this, copyItems);
            }
static addManyIssueInvoicePaymentTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BackOfficeInvoiceConfig.addIssueInvoicePaymentTypes($this, items[i]);
                }
            }
static addIssueInvoicePaymentTypes = ($this, item) => {
                if ($this.IssueInvoicePaymentTypes == null) $this.IssueInvoicePaymentTypes = [];
                if (item == null || $this.IssueInvoicePaymentTypes.indexOf(item) > -1) return;
                $this.IssueInvoicePaymentTypes.push(item);
}
static addRangeIssueInvoicePaymentTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BackOfficeInvoiceConfig.addIssueInvoicePaymentTypes($this, item));
            }
static removeIssueInvoicePaymentTypes = ($this, item) => {
                if ($this == null || $this.IssueInvoicePaymentTypes == null || $this.IssueInvoicePaymentTypes.indexOf(item) === -1) return;
                var _index = $this.IssueInvoicePaymentTypes.indexOf(item);
                $this.IssueInvoicePaymentTypes.splice(_index, 1);
}
static clearIssueInvoicePaymentTypes = ($this) => { $this.IssueInvoicePaymentTypes = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}